import React, { useEffect, useState, useContext } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Grid,
  Checkbox,
} from "@mui/material";
import CreateIcon from "../Assets/create-icon.svg";
import { useQuery } from "@apollo/client";
import moment from "moment";
//src
import FooterPagination from "../Components/Include/FooterPagination";
import LoadingPage from "../Components/Include/LoadingPage";
import EmptyData from "../Components/Include/EmptyData";
import { AuthContext } from "../Context/AuthContext";
import CreateStudentBook from "../Components/StudentBook/CreateStudentBook";
import StudentBookAction from "../Components/StudentBook/StudentBookAction";
import { GET_STUDENT_BOOK_PAGINATION } from "../Schema/StudentBook";
import {
  SelectStudent,
  SelectAcademicYear,
  SelectEnrollByStudent,
  SelectClassByAcademicYear,
} from "../Components/Include/DynamicSelect";

export default function StudentBook() {
  //
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [studentVal, setStudentVal] = useState({ id: "", title: "" });
  const [academicVal, setAcademicVal] = useState({ id: "", title: "" });
  const [enrollmentId, setEnrollmentVal] = useState({
    id: "",
    title: "",
  });
  const [classId, setClassId] = useState({
    id: "",
    title: "",
  });

  const [openCreate, setOpenCreate] = useState(false);
  const handleOpenCreate = () => setOpenCreate(true);
  const handleCloseCreate = () => setOpenCreate(false);

  //==================== ====================
  const { refetch } = useQuery(GET_STUDENT_BOOK_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      keyword: keyword,
      pagination: true,
      academicYearId: academicVal?.id ? academicVal?.id : "",
      studentId: studentVal?.id ? studentVal.id : "",
      classId: classId?.id ? classId?.id : "",
    },
    onCompleted: ({ getStudentBookPagination }) => {
      // console.log("getStudentBookPagination::", getStudentBookPagination)
      //
      setTableData(getStudentBookPagination?.data);
      setPaginationData(getStudentBookPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  // console.log("enrollmentId?.id::::", enrollmentId?.id)
  // console.log("classId?.id ::::", classId?.id )

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  useEffect(() => {
    setLoading(true);
    refetch();
  }, [academicVal?.id, classId?.id, studentVal?.id, enrollmentId?.id]);

  //
  const handleCheckItemBookType = (arrayItem) => {
    // console.log("arrayItem:::", arrayItem);
    //
    let itemStatus = false;
    const BreakException = {};
    try {
      arrayItem?.forEach(function (elem) {
        // id category book
        if (
          elem?.listMaterialUnitId?.materialId?.sectionId?._id ===
          "66a446af764aab2e5a12e68c"
        ) {
          itemStatus = true;
          throw BreakException;
        } else {
          itemStatus = false;
        }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    }
    return itemStatus;
  };

  const handleCheckItemUniformClothesType = (arrayItem) => {
    let itemStatus = false;
    const BreakException = {};
    try {
      // console.log("arrayItem:::", arrayItem);
      // Uniform - Clothes
      arrayItem?.forEach(function (elem) {
        if (
          elem?.listMaterialUnitId?.materialId?.sectionId?._id ===
            "66a445b1764aab2e5a12e658" &&
          elem?.listMaterialUnitId?.materialId?.levelSectionId?._id !==
            "68a571f3d10c3740e7f2a632"
        ) {
          itemStatus = true;
          throw BreakException;
        } else {
          itemStatus = false;
        }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    }
    return itemStatus;
  };

  const handleCheckItemUniformBagType = (arrayItem) => {
    let itemStatus = false;
    const BreakException = {};
    try {
      console.log("arrayItem:::", arrayItem);
      // Uniform - Clothes
      arrayItem?.forEach(function (elem) {
        if (
          elem?.listMaterialUnitId?.materialId?.sectionId?._id ===
            "66a445b1764aab2e5a12e658" &&
          elem?.listMaterialUnitId?.materialId?.levelSectionId?._id ===
            "68a571f3d10c3740e7f2a632"
        ) {
          itemStatus = true;
          throw BreakException;
        } else {
          itemStatus = false;
        }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    }
    return itemStatus;
  };

  // useEffect(() => {
  //   if(enrollmentId?.id) {
  //     setClassId({
  //       id: "",
  //       title: "",
  //     })
  //   }
  //   if(classId?.id) {
  //     setEnrollmentVal({
  //       id: "",
  //       title: "",
  //     })
  //   }
  // }, [classId?.id,enrollmentId?.id]);

  const handleGetAdminFee = (rowData) => {
    let arrayFilter = [];

    rowData?.map((e) => {
      e?.additionalFee?.map((rowFee) => {
        // console.log(rowFee?.incomeHead?.incomeType);
        if (rowFee?.incomeHead?.incomeType === "AdminFee") {
          arrayFilter.push(rowFee);
        }
      });
    });

    return arrayFilter;
  };

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">សម្ភារៈសិស្ស</Typography>
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={4} md={4} lg={3} xl={2.4}>
            <Typography className="field-title">សិស្ស</Typography>
            <SelectStudent
              className="search-field"
              selectedVal={studentVal}
              setSelectedVal={setStudentVal}
            />
          </Grid>

          <Grid item xs={6} sm={4} md={4} lg={3} xl={2.4}>
            <Typography className="field-title">ឆ្នាំសិក្សា</Typography>
            <SelectAcademicYear
              status={true}
              className="search-field"
              selectedVal={academicVal}
              setSelectedVal={setAcademicVal}
              checkDiabled={studentVal?.id}
            />
          </Grid>

          <Grid item xs={6} sm={4} md={4} lg={3} xl={2.4}>
            <Typography className="field-title">ថ្នាក់</Typography>

            {/* {
            studentVal?.id ?
              <SelectEnrollByStudent
                className="search-field"
                setSelectedVal={setEnrollmentVal}
                selectedVal={enrollmentId}
                studentId={studentVal?.id}
                academicId={academicVal?.id}
              />
            : */}
            <SelectClassByAcademicYear
              disabled={academicVal?.id ? false : true}
              className="search-field"
              setSelectedVal={setClassId}
              selectedVal={classId}
              academicId={academicVal?.id}
            />
            {/* }  */}
          </Grid>

          <Grid item xs={6} sm={12} md={12} lg={3} xl={4.8}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpenCreate}
                className="btn-create"
                startIcon={
                  <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                }
              >
                បង្កើត
              </Button>
            </Stack>

            {openCreate && (
              <CreateStudentBook
                open={openCreate}
                handleClose={handleCloseCreate}
                setRefetch={refetch}
              />
            )}
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell
                  rowSpan={2}
                  className="header-title-start"
                  width="6%"
                >
                  ល.រ
                </TableCell>
                <TableCell rowSpan={2} className="header-title" width="10%">
                  កាលបរិច្ឆេទ
                </TableCell>
                <TableCell rowSpan={2} className="header-title" width="16%">
                  ឈ្មោះសិស្ស
                </TableCell>
                <TableCell rowSpan={2} className="header-title" width="16%">
                  ថ្នាក់
                </TableCell>
                <TableCell rowSpan={2} className="header-title" width="10%">
                  ថ្លៃរដ្ឋបាល
                </TableCell>
                <TableCell rowSpan={2} className="header-title" width="8%">
                  សៀវភៅ
                </TableCell>
                <TableCell
                  colSpan={2}
                  align="center"
                  className="header-title"
                  width="8%"
                >
                  ឯកសណ្ឋាន
                </TableCell>
                <TableCell
                  rowSpan={2}
                  className="header-title"
                  width="10%"
                  align="center"
                >
                  អ្នកប្រគល់
                </TableCell>
                <TableCell rowSpan={2} className="header-title" width="16%">
                  ផ្សេងៗ
                </TableCell>
                <TableCell
                  rowSpan={2}
                  className="header-title-end"
                  width="26%"
                ></TableCell>
              </TableRow>

              <TableRow>
                <TableCell className="header-title" align="center" width="8%">
                  សម្លៀកបំពាក់
                </TableCell>
                <TableCell className="header-title" align="center" width="8%">
                  កាបូប
                </TableCell>
              </TableRow>
            </TableHead>

            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={11} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={11} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody className="body">
                    {tableData?.map((row, index) => {
                      // console.log("row::", row);
                      return (
                        <TableRow className="body-row" key={index}>
                          <TableCell className="body-cell-start">
                            {index + paginationData?.slNo}
                          </TableCell>

                          <TableCell className="body-cell">
                            <Typography className="member-name">
                              {moment(row?.date)?.format("DD-MM-YYYY")}
                            </Typography>
                          </TableCell>

                          <TableCell className="body-cell">
                            <Typography className="member-name">
                              {row?.studentId?.firstName +
                                " " +
                                row?.studentId?.lastName}
                            </Typography>
                          </TableCell>

                          <TableCell className="body-cell">
                            <Typography className="member-name">
                              {row?.enrollmentId?.classId?.gradeId?.gradeName +
                                " " +
                                row?.enrollmentId?.classId?.className}
                            </Typography>
                          </TableCell>

                          <TableCell className="body-cell">
                            <Typography className="member-name">
                              {handleGetAdminFee(row?.enrollmentId?.invoices)
                                ?.length > 0
                                ? handleGetAdminFee(
                                    row?.enrollmentId?.invoices,
                                  )?.map((row) => "$ " + row?.total)
                                : "$ -"}
                            </Typography>
                          </TableCell>

                          <TableCell className="body-cell">
                            <Checkbox
                              checked={handleCheckItemBookType(
                                row?.provideBooks,
                              )}
                            />
                          </TableCell>

                          <TableCell className="body-cell" align="center">
                            <Checkbox
                              checked={handleCheckItemUniformClothesType(
                                row?.provideBooks,
                              )}
                            />
                          </TableCell>

                          <TableCell className="body-cell" align="center">
                            <Checkbox
                              checked={handleCheckItemUniformBagType(
                                row?.provideBooks,
                              )}
                            />
                          </TableCell>

                          <TableCell className="body-cell" align="center">
                            <Typography className="member-name">
                              {row?.createdBy?.mainUserId?.firstName +
                                " " +
                                row?.createdBy?.mainUserId?.lastName}
                            </Typography>
                          </TableCell>

                          <TableCell className="body-cell">
                            <Typography className="member-name">
                              {row?.remark}
                            </Typography>
                          </TableCell>

                          <TableCell className="body-cell-end" align="right">
                            <StudentBookAction
                              editData={row}
                              setRefetch={refetch}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
      </Box>

      {/* ================================ Pagination ============================= */}
      <FooterPagination
        totalPages={paginationData?.totalPages}
        totalDocs={paginationData?.totalDocs}
        limit={limit}
        page={page}
        setPage={setPage}
        handleLimit={handleLimit}
        setLoading={setLoading}
      />
    </div>
  );
}
